<div class="sidebar-inner" [class.collapsed]="collapsed">

  <!-- Sidebar Header with hamburger button -->
  <div class="sidebar-header" [class.collapsed]="collapsed">
    <span class="sidebar-brand-text" *ngIf="!collapsed">CloudLabs</span>
    <button mat-icon-button (click)="toggleSidebar.emit()" class="sidebar-toggle-btn" aria-label="Toggle sidebar">
      <mat-icon>menu</mat-icon>
    </button>
  </div>

  <mat-nav-list dense>
    <a mat-list-item *ngFor="let page of pages" [routerLink]="sanitizeRoute(page.route)" routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: false }" class="sidebar-item" [class.collapsed]="collapsed"
      [matTooltip]="page.displayName" matTooltipPosition="right" matTooltipShowDelay="600">
      <mat-icon matListItemIcon [matBadge]="unreadCount"
        [matBadgeHidden]="page.route !== '/notifications' || unreadCount === 0" matBadgeColor="warn"
        matBadgeSize="medium">{{ getMaterialIcon(page.faIcon) }}</mat-icon>
      <span matListItemTitle *ngIf="!collapsed">{{ page.displayName }}</span>
    </a>
  </mat-nav-list>

</div>